import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerInstagramProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerInstagramProfileOverview = (props: InfluencerInstagramProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
